const nodes = [
  // Economía - Estructura
  { data: { id: 'mec', label: 'Ministerio de Economía' }, classes: 'org' },
  { data: { id: 'mec-alt', label: 'Subsecretaría Administrativa, Legal y Técnica', dependency: 'mec' }, classes: 'nivel1' },
  { data: { id: 'mec-info', label: 'Informática\n--------------\nEconomía', sublabel: 'Economía', dependency: 'mec-alt' }, classes: 'nivel2'},
  { data: { id: 'mec-rec', label: 'Recupero\n--------------\nEconomía', sublabel: 'Economía', dependency: 'mec-alt' }, classes: 'nivel2' },
  { data: { id: 'mec-inmuebles', label: 'Inmuebles Fiscales\n--------------\nEconomía', sublabel: 'Economía', dependency: 'mec-alt' }, classes: 'nivel2' },
  { data: { id: 'mec-rp', label: 'Registro de la Propiedad\n--------------\nEconomía', sublabel: 'Economía', dependency: 'mec-alt' }, classes: 'nivel2' },
  { data: { id: 'mec-eclab', label: 'Economía Política Laboral\n--------------\nEconomía', sublabel: 'Economía', dependency: 'mec-alt'}, classes: 'nivel2' },
  { data: { id: 'mec-coord', label: 'Subsecretaría de Coordinación Económica y Estadística', dependency: 'mec' }, classes: 'nivel1'},
  { data: { id: 'mec-muni', label: 'Coordinación Municipal\n--------------\nEconomía',  sublabel: 'Economía', dependency: 'mec-coord' }, classes: 'nivel2', },
  { data: { id: 'mec-est', label: 'Estadistica\n--------------\nEconomia', sublabel: 'Economía', dependency: 'mec-coord' }, classes: 'nivel2' },
  { data: { id: 'mec-hac', label: 'Subsecretaría de Hacienda', dependency: 'mec' }, classes: 'nivel1' },
  { data: { id: 'mec-pt', label: 'Política Tributaria\n--------------\nEconomía',  sublabel: 'Economía', dependency: 'mec-hac' }, classes: 'nivel2' },
  { data: { id: 'mec-fin', label: 'Subsecretaría de Finanzas', dependency: 'mec' }, classes: 'nivel1' },
  { data: { id: 'mec-ip', label: 'Inversión Pública\n--------------\nEconomía',  sublabel: 'Economía', dependency: 'mec-fin' }, classes: 'nivel2' },
  // Economía - Sistemas
  { data: { id: 'censos', label: 'Estadística Censos' }, classes: 'sistema' },
  { data: { id: 'sulh', label: 'SULH' }, classes: 'sistema' },
  { data: { id: 'recupero', label: 'Recupero' }, classes: 'sistema' },
  { data: { id: 'sic', label: 'SIC - Registro Propiedad' }, classes: 'sistema' },
  { data: { id: 'inmuebles', label: 'Inmuebles Fiscales' }, classes: 'sistema' },
  { data: { id: 'rafam', label: 'RAFAM' }, classes: 'sistema' },
  { data: { id: 'simco', label: 'SIMCO' }, classes: 'sistema' },
  { data: { id: 'bapin', label: 'BAPIN - Banco Proyecto' }, classes: 'sistema' },
  { data: { id: 'histsal', label: 'Historial laboral y salarial' }, classes: 'sistema' },

  // TGP - Estructura 
  { data: { id: 'tgp', label: 'TGP' }, classes: 'org' },
  { data: { id: 'tgp-info', label: 'Sistemas', dependency: 'tgp' }, classes: 'nivel2' },
  // TGP - Sistemas
  { data: { id: 'transf', label: 'Sistema de Transferencia' }, classes: 'sistema' },
  
  // CGP - Estructura
  { data: { id: 'cgp', label: 'CGP' }, classes: 'org' },
  { data: { id: 'cgp-info', label: 'Sistemas', dependency: 'cgp' }, classes: 'nivel2' },
  // CGP - Sistemas
  { data: { id: 'sigaf', label: 'SIGAF' }, classes: 'sistema' },

  // ARBA - Estructura
  { data: { id: 'arba', label: 'ARBA' }, classes: 'org' },
  { data: { id: 'reca', label: 'Subdirección Ejecutiva de Recaudación y Catastro', dependency: 'arba' }, classes: 'nivel1' },
  { data: { id: 'reca-cat', label: 'Catastro y Geodesia\n--------------\nARBA', sublabel: 'ARBA', dependency: 'reca' }, classes: 'nivel2' },
  { data: { id: 'reca-et', label: 'Estudios Económicos y Estadísticas Tributarias\n--------------\nARBA', sublabel: 'ARBA', dependency: 'reca' }, classes: 'nivel2' },
  // ARBA - sistemas
  { data: { id: 'arba-inmuebles', label: 'Inmuebles Fiscales ARBA' }, classes: 'sistema' },
  { data: { id: 'arba-geo', label: 'Geo ARBA' }, classes: 'sistema' },

  // Secreataria General - estructura
  { data: { id: 'sg', label: 'Secretaría Genaral' }, classes: 'org' },
  { data: { id: 'sg-gestion', label: 'Gestión y Emeplo Público', dependency: 'sg' }, classes: 'nivel1' },
  { data: { id: 'sg-empleo', label: 'Empleo Público\n--------------\nSecretaría Genaral', sublabel:'Secretaría Genaral', dependency: 'sg-gestion' }, classes: 'nivel2' },
   // Secreataria General - sistemas
  { data: { id: 'siape', label: 'SIAPE' }, classes: 'sistema' },

  // Gobierno Digital - estructura
  { data: { id: 'mgob', label: 'Ministerio de Gobierno' }, classes: 'org' },
  { data: { id: 'mgob-gdig', label: 'Subsecretaría de Gobierno Digital', dependency: 'mgob' }, classes: 'nivel1' },
  { data: { id: 'dpsit', label: 'DPSIT\n--------------\nGobierno Digital', sublabel:'Gobierno Digital', dependency: 'mgob-gdig' }, classes: 'nivel2' },
  // Gobierno Digital - sistemas
  { data: { id: 'form', label: 'Formulario Dinámico' }, classes: 'sistema' },
  { data: { id: 'siep', label: 'SIEP - Sistema de Pago electrónico' }, classes: 'sistema' },
  
  // Infraestructura - estructura       
  { data: { id: 'minfra', label: 'Ministerio de Infraestructra y Obras Públicas' }, classes: 'org' },
  { data: { id: 'minfra-alt', label: 'Subsecretaría Administrativa, Legal y Técnica', dependency: 'minfra' }, classes: 'nivel1' },
  { data: { id: 'minfra-Info', label: 'Tecnología\n--------------\nInfra', sublevel:'Infra', dependency: 'minfra-alt' }, classes: 'nivel2' },
  // Infraestructura - sistemas
  { data: { id: 'tablero', label: 'Tablero' }, classes: 'sistema' },
  { data: { id: 'seguimiento', label: 'Seguimiento de Obra' }, classes: 'sistema' },

  // Salud - estructura  
  { data: { id: 'msalud', label: 'Ministerio de Salud' }, classes: 'org' },
  { data: { id: 'samo', label: 'SAMO\n--------------\nSalud', sublabel:'Salud', dependency: 'msalud' }, classes: 'nivel2' },
  // Salud - sistemas 
  { data: { id: 'fact', label: 'Sistema de Facturación SAMO' }, classes: 'sistema' },
  { data: { id: 'sipach', label: 'SIPACH' }, classes: 'sistema' },

  // BAPRO - estructura
  { data: { id: 'bapro', label: 'BAPRO' }, classes: 'org' },
  // BAPRO - estructura
  { data: { id: 'bapro-Copa', label: 'Coparticipación Municipal' }, classes: 'sistema' },

  // IOMA - estructura
  { data: { id: 'ioma', label: 'IOMA' }, classes: 'org' },
  // IOMA - sistemas
  
  // OPC (org prov contrataciones) - estructura
  { data: { id: 'opc', label: 'OPC' }, classes: 'org' },
  // ODP - sistema
  { data: { id: 'pbac', label: 'PBAC' }, classes: 'sistema' },

  // IPS - estructura
  { data: { id: 'ips', label: 'IPS' }, classes: 'org' },
  // IPS - sistemas
  { data: { id: 'rupa', label: 'RUPA: Registro Único Permanente de Afiliados Descripción:BAC' }, classes: 'sistema' },
  { data: { id: 'sap', label: 'SAP: Sistema de administración previsional' }, classes: 'sistema' },
  { data: { id: 'autogestion', label: 'Servicio de autogestión online para trámites' }, classes: 'sistema' },
  { data: { id: 'webijd', label: 'Trámites Digitales (WebIJD)' }, classes: 'sistema' },
  { data: { id: 'siceep', label: 'SICEEP – Gestión de establecimientos educativos privados' }, classes: 'sistema' },
  { data: { id: 'ips-deudas', label: 'Gestion deudas con el IPS' }, classes: 'sistema' },
  { data: { id: 'ips-fallecidos', label: 'Cruces de fallecidos e incompatibilidades' }, classes: 'sistema' },

  // DGCYE - estructura
  { data: { id: 'dgcye', label: 'DGCyE'}, classes: 'org' },
  { data: { id: 'dgcye-educ', label: 'Subsecretaría de Educación', dependency: 'dgcye' }, classes: 'nivel1' },
  { data: { id: 'dgcye-plan', label: 'Susecreataría de Planeamiento', dependency: 'dgcye' }, classes: 'nivel1' },
  { data: { id: 'dgcye-infra', label: 'Subsecretaría de Infraestructura Escolar', dependency: 'dgcye' }, classes: 'nivel1' },
  { data: { id: 'dgcye-admrrhh', label: 'Subsecretaría de Administración y RRHH', dependency: 'dgcye' }, classes: 'nivel1' },
  { data: { id: 'dgcye-rrhh', label: 'RRHH\n--------------\nEscuelas', sublabel:'Escuelas', dependency: 'dgcye-admrrhh' }, classes: 'nivel2' },
  { data: { id: 'dgcye-fin', label: 'Administración Financiera\n--------------\nEscuelas', sublabel:'Adm Financiera', dependency: 'dgcye-admrrhh' }, classes: 'nivel2' },
  // DGCYE - sistemas
  { data: { id: 'esc-lic', label: 'Sistema de Licencias'}, classes: 'sistema' },
  { data: { id: 'esc-aux', label: 'Sistema de Inscripción a la docencia- Auxiliares'}, classes: 'sistema' },
  { data: { id: 'esc-art', label: 'ART'}, classes: 'sistema' },
  { data: { id: 'esc-hv', label: 'Jubilaciones - Hoja de Vida'}, classes: 'sistema' },
  { data: { id: 'esc-suna', label: 'SUNA'}, classes: 'sistema' },
  { data: { id: 'esc-boletin', label: 'Boletín Digital'}, classes: 'sistema' },
  { data: { id: 'esc-aprender', label: 'Evaluaciones Aprender'}, classes: 'sistema' },
  { data: { id: 'esc-coope', label: 'Cooperadoras'}, classes: 'sistema' },
  { data: { id: 'esc-host', label: 'Liquidación Oficial - Procesos TPS'}, classes: 'sistema' },
  { data: { id: 'esc-sicoinse', label: 'Sistema de Contabilidad Integral para Consejos Escolares'}, classes: 'sistema' },  
  { data: { id: 'esc-apd', label: 'APD - Hoja de Ruta y Nuevos Planes'}, classes: 'sistema' },
  { data: { id: 'esc-f572', label: 'Aplicación F572'}, classes: 'sistema' },
  { data: { id: 'esc-liq-of', label: 'Liquidación Oficial - Procesos TPS'}, classes: 'sistema' },
  { data: { id: 'esc-liq-priv', label: 'Liquidación DIEGEP'}, classes: 'sistema' },
  { data: { id: 'esc-liq-inc', label: 'Liquidación de Incentivo Docente - Procesos INC'}, classes: 'sistema' },
  { data: { id: 'esc-liq-incp', label: 'Liquidación de Incentivo Docente - Procesos INCP'}, classes: 'sistema' },
  { data: { id: 'esc-liq-conn', label: 'Liquidación de Conectividad Nacional - Procesos MAT'}, classes: 'sistema' },
  { data: { id: 'esc-liq-incn', label: 'Valorización Trimestral de Incentivo Docente - Procesos INCN'}, classes: 'sistema' },
  { data: { id: 'esc-liq-alc', label: 'Liquidación de Alcances Oficial - Procesos ALCP'}, classes: 'sistema' },
  { data: { id: 'esc-liq-rec', label: 'Liquidación de Receso Oficial - Procesos RECU'}, classes: 'sistema' },
  { data: { id: 'esc-liq-viat', label: 'Liquidación de Viáticos - Procesos VIAT'}, classes: 'sistema' },
  { data: { id: 'esc-liq-hext', label: 'Liquidación de Horas Extras - Procesos HEXT'}, classes: 'sistema' },
  { data: { id: 'esc-liq-tps', label: 'Bancarización - Procesos TPS'}, classes: 'sistema' },
  { data: { id: 'esc-liq-boni', label: 'Bonificaciones, Descuentos y Adicionales - Online'}, classes: 'sistema' },
  { data: { id: 'esc-liq-fam', label: 'Salario Familiar - Online'}, classes: 'sistema' },
  { data: { id: 'esc-liq-priv-adic', label: 'Adiciones DIEGEP - Online'}, classes: 'sistema' },
  { data: { id: 'esc-liq-inasis', label: 'Inasistencias y Licencias - Online'}, classes: 'sistema' },
  { data: { id: 'esc-liq-priv-ret', label: 'Retenciones a Establecimientos Privados'}, classes: 'sistema' },
  { data: { id: 'esc-liq-afip', label: 'Liquidación de Ganancias 4TA Categoría AFIP'}, classes: 'sistema' },
  { data: { id: 'esc-rrhh-of', label: 'RRHH Oficial'}, classes: 'sistema' },
  { data: { id: 'esc-rrhh-priv', label: 'RRHH DIEGEP'}, classes: 'sistema' },
  { data: { id: 'esc-mad', label: 'M.A.D.'}, classes: 'sistema' },
  { data: { id: 'esc-tit', label: 'Registro de Títulos'}, classes: 'sistema' },
  { data: { id: 'esc-receso', label: 'Liquidación de Ganancias 4TA Categoría AFIP'}, classes: 'sistema' },
  { data: { id: 'esc-dineraria-art', label: 'Dinerarias por ART'}, classes: 'sistema' },
  { data: { id: 'esc-hhee', label: 'Horas Extras'}, classes: 'sistema' },
  { data: { id: 'esc-jub-cert', label: 'Jubilaciones y Certificaciones'}, classes: 'sistema' },
  { data: { id: 'esc-fojero', label: 'Fojero'}, classes: 'sistema' },
  { data: { id: 'esc-op', label: 'Órdenes de Pago'}, classes: 'sistema' },
  { data: { id: 'esc-anticipo', label: 'Anticipo Jubilatorio'}, classes: 'sistema' },
  { data: { id: 'esc-est', label: 'Establecimientos'}, classes: 'sistema' },
  { data: { id: 'esc-prov-sup', label: 'Servicios Provisionales y Suplentes'}, classes: 'sistema' },



];

export default nodes